module.exports = __webpack_public_path__ + "img/Soudal.cf64d4f4.jpg";